import React from 'react'
import ReactDOM from 'react-dom'
import 'animate.css'
import './index.css'
import Confetti from 'react-dom-confetti';

import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))
